import { createRouter } from '@tanstack/react-router';
import { queryClient } from '@/lib/query-client';
import {
  ConsultantNotFoundScreen,
  ConsultantRouterErrorScreen,
} from '@/shared/global-error-screens';
import { routeTree } from './route-tree';

export const router = createRouter({
  routeTree,
  context: { query: queryClient },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  // EU-686 (RN-20/22/25) — erros SISTÊMICOS assumem a tela inteira com as
  // telas globais da variante Consultants (menu mantido; sessão expirada
  // vive no KeycloakGate, acima do router).
  defaultErrorComponent: ConsultantRouterErrorScreen,
  defaultNotFoundComponent: ConsultantNotFoundScreen,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
